import React from "react";
import { Card, CardContent, Grid, styled, Typography } from "@mui/material";
import { MemberPayment } from "../../../service/model/member-payment.model";
import { toTitleCase } from "../../../shared/utils";
import { CheckCircleOutlineIcon } from "../../../shared/icons";

const StyledCard = styled(Card)(({ theme }) => ({
    marginTop: "12px",
    '& .MuiCardContent-root': {
        paddingBottom: '12px !important',
    }
}));

interface PaymentHistoryProps {
    payments: MemberPayment[];
}

const PaymentHistory: React.FC<PaymentHistoryProps> = ({ payments }) => {

    return (
        <div style={{ marginTop: '12px' }}>
            <Typography variant="h6">Payment History</Typography>
            {payments.map(payment => {
                return <StyledCard key={payment.id}>
                    <CardContent sx={{ pb: '12px' }}>
                        <Grid container alignItems="center">
                            <Grid size={{ xs: 12, md: 3 }}>
                                <Typography sx={{ color: 'text.secondary', fontSize: 14 }} align="left">
                                    {payment.paymentDate}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, md: 3 }}>
                                <Typography sx={{ color: 'text.secondary', fontSize: 14 }} align="left">
                                    Rs. {payment.amount}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 10, md: 4 }}>
                                <Typography sx={{ color: 'text.secondary', fontSize: 14 }} align="left">
                                    {toTitleCase(payment.category.replace('_', ' '))}
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 2 }}>
                                <CheckCircleOutlineIcon color="success" />
                            </Grid>
                        </Grid>
                    </CardContent>
                </StyledCard>
            })

            }
        </div>
    );
}

export default PaymentHistory;